import { render, staticRenderFns } from "./Compare02.vue?vue&type=template&id=74bd2c9c&"
import script from "./Compare02.vue?vue&type=script&lang=ts&"
export * from "./Compare02.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports